<template>
  <div class="p-grid">
    <div class="p-col-12">
      <div class="card card-w-title">
        <div class="manager-title">Quản lý phân quyền</div>
      </div>
      <div class="card card-w-title" v-if="display_page">
        <div class="box-top-list">
          <span class="p-m-0">{{ titleModel }} </span>
          <span class="right-button">
            <Button class="p-button-warning" :label="'Quay lại'" @click="backList" />
            <Button :disabled="submitForm" class="p-button-success btn-custom" :label="labelName" @click="saveData" />
          </span>
          <div class="clearfix"></div>
        </div>
        <div class="list-data-permission">
          <div class="p-fluid p-formgrid p-grid">
            <div class="p-field p-col-12 p-md-6">
              <div class="p-col-12">
                <label for="name">Tên quyền truy cập<span class="error">*</span></label>
                <InputText id="name" type="text" v-model="name"/>
                <small v-if="validationErrors && validationErrors['name']"
                    class="p-invalid" >{{validationErrors['name']}}</small>
                <small v-if="name_exists"
                class="p-invalid" >Tên quyền truy cập bị trùng</small>
              </div>
              <div class="p-col-12">
                <div class="p-grid">
                  <div class="p-col-6">
                    <div class="p-field">
                      <!--<div class="p-field-checkbox">
                          <Checkbox  v-model="is_management_lower_level" :binary="true"/>
                          <label >Quản lý dữ liệu cấp dưới</label>
                      </div>-->
                      <label for="name">Quyền truy cập Mobile App<span class="error">*</span></label>
                      <Dropdown :filter="false" placeholder="Chọn quyền truy cập Mobile App" v-model="id_role_access" :options="list_role_accessaccess_mobile" optionLabel="name"  optionValue="id" />
                      <small v-if="validationErrors && validationErrors['id_role_access']"
                             class="p-invalid" >{{validationErrors['id_role_access']}}</small>
                    </div>
                  </div>
                  <div class="p-col-6 style-box-display-agent" >
                    <div class="p-field">
                      <div class="p-field-checkbox">
                          <Checkbox  v-model="status" :binary="true"/>
                          <label >Hiển thị cho đại lý phân quyền</label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="p-field p-col-12 p-md-6">
              <div class="p-col-12">
                <label for="parent_id">Mô tả</label>
                <Textarea  id="description" rows="3"  v-model="description" :autoResize="true"/>
              </div>
            </div>
            
            <div class="box-tabview">
              <TabView @tab-change="clickChange">
                <TabPanel :key="'0'"   header="Web app" >
                  <Module v-if="activeIndex == 0" :key="componentKey" @change="changeChecked" :permissions="permissonAllWeb" :type="'web'"/>
                </TabPanel>
                <TabPanel :key="'1'"  header="Mobile app" >
                  <Module v-if="activeIndex == 1" :key="componentKey" @change="changeChecked" :permissions="permissonAllMobile" :type="'mobile'"/>
                </TabPanel>
              </TabView>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DataServices from '@/core/DataServices'
import Module from './module'
export default {
  components: {
    Module
  },
  data() {
    return {
      modelPermissionData: [],
      dataModel: null,
      componentKey: 0,
      modelName: 'roles',
      name: '',
      description: '',
      activeIndex: 0,
      validationErrors: {},
      name_exists: false,
      roleID: 0,
      permissonAllWeb: [],
      permissonAllMobile: [],
      type: 'web',
      submitForm: false,
      is_management_lower_level: false,
      status: true,
      labelName: 'Tạo',
      titleModel: ' Tạo mới quyền truy cập',
      display_page:true,
      list_role_accessaccess_mobile:[],
      id_role_access:null
    }
  },
  async mounted () {
    var vm = this;
    this.dataModel = DataServices.getModel(this.modelName);
    if (this.$route.params.id !== undefined && !isNaN(this.$route.params.id)) {
      if (!vm.$myConstants.checkRoleGroup('role', 'edit')){
        vm.display_page = false;
      }
      this.roleID = Number(this.$route.params.id);
      await this.getData();
    }else {
      if (!vm.$myConstants.checkRoleGroup('role', 'add')){
        vm.display_page = false;
      }
    }
    this.list_role_access();
  },
  methods: {
    async getData() {
      var variables = {
        where_key: {
          id: {'_eq': this.roleID}
        }
      }
      var data = await DataServices.getList(this.modelName, {"variables": JSON.stringify(variables), "fields": "id name description is_management_lower_level role_access_id status role_permission(where: {status: {_eq: 1} }) { id role_id permission_id permission { type }}"});
      var list = data[Object.keys(data)];
      if (list != null && Object.keys(list).length) {
        this.labelName = 'Lưu';
        this.titleModel = 'Chỉnh sửa quyền truy cập';
        var model = list[0];
        this.modelPermissionData = model;
        this.name = model.name;
        this.description = model.description;
        this.is_management_lower_level = model.is_management_lower_level;
        this.status = model.status;
        this.id_role_access = model.role_access_id;
        var modelData = (model.role_permission != undefined && model.role_permission != null) ? model.role_permission : [];
        if(modelData) {
          for (let index = 0; index < modelData.length; index++) {
            const item = modelData[index];
            if(item.permission != undefined & item.permission != null && item.permission.type != undefined && item.permission.type != '') {
              if (item.permission.type == 'web') this.permissonAllWeb[item.permission_id] = true;
              else if (item.permission.type == 'mobile') this.permissonAllMobile[item.permission_id] = true;
            }
          }
        }
      }
      this.componentKey = Math.random() * 1020;
    },
    backList() {
       this.$router.push({path: '/admin/role'});
    },
    async clickChange($event) {
      this.activeIndex = parseInt($event.tab.$vnode.data.key);
      await this.getData();
    },
    changeChecked(payload) {
      if (payload.type == 'web') {
        this.permissonAllWeb = payload.lists;
      } else if (payload.type == 'mobile') {
        this.permissonAllMobile = payload.lists;
      }
    },
    async checkName() {
      this.name = this.name.trim();
      if (this.name !== undefined && this.name !== "") {
        var where = { name: {'_ilike': this.name} }
        if (this.modelPermissionData != null) where = Object.assign(where, {id: {'_neq': this.modelPermissionData.id}})
        var data = await DataServices.getList(this.modelName, {"fields": "id", "variables": JSON.stringify({where_key: where})});
        return data && data[Object.keys(data)].length > 0
      }
    },
    async processPermission() {
      var permissionName = 'role_permission';
      var count = 0;
      // xoá tất cả các quyền đã thêm trước đó
      if (this.modelPermissionData &&  this.roleID > 0) {
        var variables = {
          where_key: {
            role_id: {'_eq': this.roleID }
          }
        }
        await DataServices.deleteData(permissionName, {"variables": JSON.stringify(variables)});
      }
      var params = [];
      var roleIDTemp = this.roleID;
      var ordering = 0;
      var that = this;
      if (this.permissonAllWeb && this.permissonAllWeb.length) {
        this.permissonAllWeb.forEach(function(value, index) {
          ordering++;
          if (value) {
            params.push({
              role_id: roleIDTemp,
              permission_id: index,
              ordering: ordering,
              created_date: that.$myConstants.currentDate(),
              modified_date: that.$myConstants.currentDate(),
              status: 1
            });
          }
        });
      }
      if (this.permissonAllMobile && this.permissonAllMobile.length) {
        this.permissonAllMobile.forEach(function(value, index) {
          ordering++;
          if (value) {
            params.push({
              role_id: roleIDTemp,
              permission_id: index,
              ordering: ordering,
              created_date: that.$myConstants.currentDate(),
              modified_date: that.$myConstants.currentDate(),
              status: 1
            });
          }
        });
      }
      if(params && params.length) {
        var dataInsert = await DataServices.insertData(permissionName, {"variables": JSON.stringify({objects: params})});
        if (dataInsert && Object.keys(dataInsert).length) count = 1;
      } else count = 1;

      if (count > 0) {
        this.$store.commit('setLoading', false);
        this.$toast.add({ severity: 'success', summary: 'Thông báo', detail: 'Cập nhật thành công', life: 3000 })
        setTimeout(() => {
          this.$router.push({path: '/admin/role'});
        }, 500);
      }
    },
    async validationData() {
      this.validationErrors = {};
      if (this.name == undefined || this.name == '') this.validationErrors['name'] = 'Nhập tên quyền truy cập';
      this.name_exists = await this.checkName();
      if (this.$myConstants.isEmpty(this.id_role_access)){
        this.validationErrors['id_role_access'] = 'Chọn quyền truy cập mobile app';
      }
      if (!(Object.entries(this.validationErrors).length === 0)) {
        //Nếu tồn tại lỗi thì force để load validator mượt
        this.$forceUpdate();
      }
    },
    async saveData() {
      this.submitForm = true;
      await this.validationData();
      if (!this.name_exists && !this.tax_number_exists && Object.entries(this.validationErrors).length === 0) {
        this.$store.commit('setDataLoading', {content: 'Đang lưu dữ liệu', icon: true});
        this.$store.commit('setLoading', true);
        var params = {
          'name': this.name,
          'description': this.description,
          'modified_date':  this.$myConstants.currentDate(),
          'is_management_lower_level': this.is_management_lower_level,
          'status': this.status ? 1 : 0,
          'role_access_id': this.id_role_access,
        }
        
        if (this.modelPermissionData != null && this.modelPermissionData.id != undefined && this.modelPermissionData.id != null && this.modelPermissionData.id > 0) {
          await DataServices.updateData(this.modelName, {"variables": JSON.stringify({data_update: params, where_key: { id: {'_eq': this.modelPermissionData.id }}})});
          await this.processPermission();
        } else {
          params = Object.assign(params, { 'created_date': this.$myConstants.currentDate() });
          var dataInsert = await DataServices.insertData(this.modelName, {"variables": JSON.stringify({objects: params})});
          var list = dataInsert[Object.keys(dataInsert)];
          if (list != null && Object.keys(list).length) {
            this.roleID = list.returning[0].id;
            await this.processPermission();
          }
        }
      } else this.submitForm = false;
    },
    async list_role_access() {
      var variables = {
        where_key: {
          status: {'_in': [1]},
          //code: {_neq: "A3"}
        },
        orderBy: {
          name: 'asc'
        }
      }
      var data = await DataServices.getList('role_access', {
        "variables": JSON.stringify(variables),
        "fields": "id,name"
      });
      var list = data[Object.keys(data)];
      this.list_role_accessaccess_mobile = list;
    },
  }
}
</script>
<style lang="scss">
.box-top-list{border: 1px solid #ccc; padding: 10px; 
  span{font-size: 25px; text-align: left; display: inline-block;}
  .right-button{float: right; 
    span{font-size: 14px;}
    .p-button{border-radius: 5px; min-width: 100px; 
      &.btn-custom{ margin-left: 10px;}
      span{text-align: center;}
    }
  }
}
.list-data-permission {border: 1px solid #ccc; border-top: 0; 
  .box-tabview{padding: 0.5em 1em; width: 100%;
    .row-item-header{
      div{display: inline-block; border: 1px solid #e9ecef; border-width: 1px 0 0 0; font-weight: 600; color: #495057; background: #f8f9fa; transition: box-shadow 0.2s; padding: 0.571rem 0.857rem;}
    }
    .row-body{
      .row-item{border: 1px solid #e9ecef; border-width: 1px 0 0 0;  padding: 0.571rem 0.857rem;
        .item{display: inline-block;  color: #495057;  transition: box-shadow 0.2s;}
      }
      &:last-child{
        .row-item {
          &:last-child { border-bottom: 1px solid #e9ecef;}
        }
      }
    }
  }
}
.style-box-display-agent{
   display: flex; align-items: center; justify-content: center;
 }
</style>